'use client';

import React, { useEffect, useState } from 'react';
import "./index.scss";
import OddTableAnalysis from "@/components/client/OddTableAnalysis";
import ICON_ARROW_UP_LEAGUES from "@/public/arrow_up_white_leagues.svg";
import ICON_ARROW_DOWN_LEAGUES from "@/public/arrow_down_white_leagues.svg";
import CollapsiblePanel from "@/components/client/CollapsiblePanel";
import MatchServices from "@/services/MatchServices";
import LoadingInner from '@/app/loadingInner';

const IMAGE_ARROW_DOWN_LEAGUES = ICON_ARROW_DOWN_LEAGUES;
const IMAGE_ARROW_UP_LEAGUES = ICON_ARROW_UP_LEAGUES;

const MatchAnalysisOdds = ({ matchId }) => {
  const [liveOdd, setLiveOdd] = useState(null);
  const [odd, setOdd] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchOdds = async () => {
      try {
        const [liveOddData, oddData] = await Promise.all([
          MatchServices.getLiveOddByMatchId(matchId),
          MatchServices.getOddByMatchId(matchId),
        ]);
        setLiveOdd(liveOddData);
        setOdd(oddData);
      } catch (error) {
        console.error("Error fetching odds data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchOdds();
  }, [matchId]);

  if (loading) {
    return (
      <CollapsiblePanel
        title="So sánh kèo trực tuyến"
        initOpen={true}
        iconUp={IMAGE_ARROW_UP_LEAGUES}
        iconDown={IMAGE_ARROW_DOWN_LEAGUES}
      >
        <LoadingInner />
      </CollapsiblePanel>
    );
  }

  return (
    <CollapsiblePanel
      title="So sánh kèo trực tuyến"
      initOpen={true}
      iconUp={IMAGE_ARROW_UP_LEAGUES}
      iconDown={IMAGE_ARROW_DOWN_LEAGUES}
    >
      <OddTableAnalysis data={odd} dataLiveOdd={liveOdd} />
    </CollapsiblePanel>
  );
};

export default MatchAnalysisOdds;
